export default __webpack_public_path__ + "static/media/edit-smile.434c92f0.png";